export const ACTION_TRANSLATIONS = {
    'CREATE': 'Vytvořeno',
    'UPDATE': 'Upraveno',
    'DELETE': 'Smazáno',
};
export const ENTITY_TYPE_TRANSLATIONS = {
    'instructor': 'Instruktor',
    'grade': 'Stupeň',
    'pricing': 'Ceník',
    'voucher': 'Voucher',
    'transaction': 'Transakce',
    'balance': 'Zůstatek',
    'reservation': 'Rezervace',
    'reservation_failed': 'Neúspěšná rezervace',
    'availability': 'Dostupnost',
    'kidSchool': 'Dětská škola',
    'pause': 'Pauza',
    'operatingHours': 'Provozní doba',
    'kidSchoolConfig': 'Konfigurace DŠ',
    'config': 'Nastavení školy',
};
export const ACTION_COLORS = {
    'CREATE': 'success',
    'UPDATE': 'primary',
    'DELETE': 'error',
};
